import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { CpqConfiguratorComponent } from '../cpq-configurator/cpq-configurator.component';
import { first } from 'rxjs';
import {
  CpqPrice,
  ProductConfigurationPriceTotalService
} from '../../../services/cpq/product-configuration-price-total.service';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from '../../../services/products/product.service';
import { ProductConfigurationService } from '../../../services/cpq/product-configuration.service';
import { ProductConfigurationRuleExecutionService } from '../../../services/cpq/product-configuration-rule-execution.service';
import { CartService } from '../../../services/cart/cart.service';
import { GungNotificationService, OptionsListMulti } from 'gung-common';
import { ProductConfigurationFeature, ProductConfigurationOption } from '../../../models/product-configuration-types';

@Component({
  selector: 'lib-cpq-configurator-inline',
  standalone: false,
  templateUrl: './cpq-configurator-inline.component.html',
  styleUrl: './cpq-configurator-inline.component.scss'
})
export class CpqConfiguratorInlineComponent extends CpqConfiguratorComponent implements OnChanges {
  totalPrice = 0;
  currency: string = '';
  private dropdownOptions = new Map<string, { key: string; options: OptionsListMulti[] }>();

  constructor(
    protected route: ActivatedRoute,
    protected productService: ProductService,
    protected productConfigurationService: ProductConfigurationService,
    protected ruleExecutionService: ProductConfigurationRuleExecutionService,
    protected cartService: CartService,
    protected gungNotificationService: GungNotificationService,
    protected productConfigurationPriceTotalService: ProductConfigurationPriceTotalService
  ) {
    super(
      route,
      productService,
      productConfigurationService,
      ruleExecutionService,
      cartService,
      gungNotificationService
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.configuration) {
      return;
    }

    this.productConfigurationPriceTotalService
      .getConfigurationTotalPrice(this.configuration, this.buildSelection())
      .pipe(first())
      .subscribe((price: CpqPrice) => {
        this.currency = price.currency;
        this.totalPrice = price.totalPrice;
      });
  }

  featureOptionSelected(feature: ProductConfigurationFeature, option: ProductConfigurationOption) {
    super.featureOptionSelected(feature, option);
    this.ngOnChanges({});
  }

  featureOptionRemoved(feature: ProductConfigurationFeature, option: ProductConfigurationOption) {
    super.featureOptionRemoved(feature, option);
    this.ngOnChanges({});
  }

  getDropdownOptions(feature: ProductConfigurationFeature): OptionsListMulti[] {
    const options = this.getFilteredOptions(feature).map(option => ({
      id: option.id,
      name: this.getOptionLabel(feature, option),
      selected: this.featureNgModels[feature.id] === option.id,
      hide: !!this.hiddenOptions.get(option.id) || !!this.disabledOptions.get(option.id)
    }));
    const key = JSON.stringify(options);
    const cached = this.dropdownOptions.get(feature.id);
    if (cached?.key === key) {
      return cached.options;
    }
    this.dropdownOptions.set(feature.id, { key, options });
    return options;
  }

  dropdownOptionSelected(feature: ProductConfigurationFeature, optionIds: string[]) {
    const option = this.keyedOptions.get(optionIds?.[0]);
    if (!option || this.featureNgModels[feature.id] === option.id) {
      return;
    }
    this.featureNgModels[feature.id] = option.id;
    this.featureOptionSelected(feature, option);
  }
}
